import * as React from "react";
import Rest from "src/services/Rest";
import './ProductGrid.scss';

import { Header, Navigation, Footer } from "../../../shared";
import { AdministrationMenu } from "../../shared/menu/AdministrationMenu";
import { ProductTableGrid } from "./ProductTableGrid";
import { ProductModal } from "./ProductModal";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Paper,
  Snackbar,
  SnackbarContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

// tslint:disable-next-line:no-empty-interface
export interface IProductGridProps {}

// tslint:disable-next-line:no-empty-interface
export interface IProductGridState {
  alertMessage: string;
  alertOpened: boolean;
  alertType: string;

  error: string | null;
  loading: boolean;
  loadingProduto: boolean;
  produto: {};
  rows?: any[];
  totalItems: number;
  viewProduto?: string;

  search: {
    fabricante: string;
    page: number;
    size: number;
    sku: string;
    title: string;
  };
}

export class ProductGrid extends React.Component<
  IProductGridProps,
  IProductGridState
> {
  constructor(props: IProductGridProps) {
    super(props);

    this.state = {
      alertMessage: "",
      alertOpened: false,
      alertType: "success",

      error: null,
      loading: false,
      loadingProduto: false,
      produto: {},
      rows: [],
      totalItems: 0,
      viewProduto: undefined,

      search: {
        fabricante: "",
        page: 0,
        size: 10,
        sku: "",
        title: "",
      },
    };

    this.clear = this.clear.bind(this);
    this.search = this.search.bind(this);
  }

  public componentDidMount() {
    this.search();
  }

  public render() {
    const { loadingProduto, produto, viewProduto, search } = this.state;
    const { page, size } = search;
    return (
      <div>
        {!!viewProduto && (
          <ProductModal
            loading={loadingProduto}
            viewProduto={viewProduto}
            onClose={this.onCloseDialog}
            produto={produto}
          />
        )}
        <Header
          title={"Listagem de Produtos"}
          name={"Administrativo"}
          link={"/dashboard"}
        />
        <Navigation
          name={"Listagem de Produtos"}
          linkDefault={"/administration/product-grid"}
          link={"/dashboard"}
          linkTitle={"Produtos"}
          painel={3}
          icon={<ChevronRightIcon />}
        />
        <div>
          <AdministrationMenu paramIcon={null} />
          <div className="wrapper">
            <Grid
              container={true}
              className="panel-grid"
              spacing={16}
            >
              <Grid item={true} xs={12}>
                <div>
                  <Paper className="analytical-panel">
                    <Grid container={true} direction="column" spacing={16}>
                      <Grid item={true}>
                        <Card>
                          <CardContent>
                            <Snackbar
                              anchorOrigin={{
                                horizontal: "center",
                                vertical: "center",
                              }}
                              open={this.state.alertOpened}
                              autoHideDuration={4000}
                              onClose={this.closeAlert}
                            >
                              <SnackbarContent
                                message={this.state.alertMessage}
                                style={this.alertStyle()}
                              />
                            </Snackbar>
                            <form>
                              <FormGroup className="search-bar" row={true}>
                                <TextField
                                  label="SKU"
                                  value={this.state.search.sku}
                                  onChange={this.handleChangeCadastro("sku")}
                                  style={this.textFieldStyle()}
                                  type="text"
                                  autoComplete="text"
                                  margin="normal"
                                  required={true}
                                />
                                <TextField
                                  label="Titulo"
                                  value={this.state.search.title}
                                  onChange={this.handleChangeCadastro("title")}
                                  style={this.textFieldStyle()}
                                  type="text"
                                  autoComplete="text"
                                  margin="normal"
                                  required={true}
                                />
                                <TextField
                                  label="Fabricante"
                                  value={this.state.search.fabricante}
                                  onChange={this.handleChangeCadastro("fabricante")}
                                  style={this.textFieldStyle()}
                                  type="text"
                                  autoComplete="text"
                                  margin="normal"
                                  required={true}
                                />
                                <FormControl
                                  required={true}
                                  margin="normal"
                                  style={this.textFieldStyle()}
                                  className="width-20"
                                >
                                  <InputLabel>Tamanho da pagina</InputLabel>
                                  <Select
                                    value={this.state.search.size}
                                    onChange={this.handleChangeCadastro("size")}
                                  >
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={50}>50</MenuItem>
                                    <MenuItem value={100}>100</MenuItem>
                                  </Select>
                                </FormControl>
                              </FormGroup>
                            </form>
                          </CardContent>
                          <CardActions>
                            <Button
                              className="filter-dialog-clear"
                              onClick={this.clear}
                            >
                              Limpar
                            </Button>
                            <Button
                              className="filter-dialog-close"
                              color="primary"
                              onClick={this.search}
                            >
                              Pesquisar
                            </Button>
                          </CardActions>
                        </Card>
                        <Card>
                          <CardContent>
                            <ProductTableGrid
                              error={this.state.error}
                              loading={this.state.loading}
                              items={[
                                { header: "SKU", row: "sku" },
                                { header: "Título", row: "titulo" },
                                { header: "Fabricante", row: "fabricante" },
                                { header: "Área Bookinfo", row: "bookinfo" },
                                { header: "Área PublishNews", row: "publishnews" },
                                { header: "Área Veja", row: "veja" },
                              ]}
                              rows={this.state.rows}
                              onViewRow={this.viewProduto}
                              handleChangePage={this.handleChangePage}
                              tableProps={{
                                limit: size,
                                page,
                                total: this.state.totalItems,
                              }}
                            />
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Paper>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className="users-register-footer">
          <Footer />
        </div>
      </div>
    );
  }

  private viewProduto = (p: any) => {
    this.setState({ viewProduto: p.sku, loadingProduto: true });
    Rest.GET(`bookinfo-produtos/${p.sku}`, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (!!result) {
          if (result.error) {
            this.openErrorAlert(result);
            this.setState({ loadingProduto: false, viewProduto: undefined });
            return;
          }
          this.setState({ produto: result, loadingProduto: false });
        }
      });
  };

  private search() {
    const { page, size, sku, fabricante, title } = this.state.search;
    this.setState({ loading: true });
    let endPoint = "bookinfo-produtos";
    let queryParam = `?page=${page}&size=${size}`;

    queryParam += this.getParams(sku, fabricante, title);

    endPoint += queryParam;

    Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (!!result) {
          if (result.error) {
            this.openErrorAlert(result);
            this.setState({ loading: false, rows: [] });
            return;
          }
          this.setState({
            loading: false,
            rows: result.products,
            totalItems: Number(result.total),
          });
        }
      });
  }

  private async clear() {
    await this.setSearch({
      fabricante: "",
      page: 0,
      size: 10,
      sku: "",
      title: "",
    });
    this.search();
  }

  private handleChangeCadastro = (param: string) => async (event: any) => {
    const search = this.state.search;
    search[param] = param.includes("size")
      ? event.target.value
      : event.currentTarget.value;
    await this.setSearch(search);
  };

  private handleChangePage = async (ev: any, page: number) => {
    const search = this.state.search;
    search.page = page;
    await this.setSearch(search);
    this.search();
  };

  private setSearch = async (search: {
    fabricante: string;
    page: number;
    size: number;
    sku: string;
    title: string;
  }) => {
    this.setState({ search });
  };

  private onCloseDialog = () => {
    this.setState({ viewProduto: undefined, produto: {} });
  };

  private openErrorAlert(err: any) {
    let message = "";
    !!err.message ? (message = err.message) : (message = err.error);
    this.setState({ alertMessage: message, alertOpened: true });
  }

  private closeAlert = (event: object, reason: string) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ alertOpened: false, alertMessage: "" });
  };

  private alertStyle = () => {
    return styles[this.state.alertType];
  };

  private textFieldStyle = () => {
    return Object.assign({}, styles.textField);
  };

  private getParams = (sku: string, fabricante: string, title: string) => {
    let queryParam = "";
    if (!!sku) {
      queryParam += `&sku=${sku}`;
    }

    if (!!fabricante) {
      queryParam += `&fabricante=${fabricante}`;
    }

    if (!!title) {
      queryParam += `&title=${title}`;
    }
    return queryParam;
  };
}



// WEBPACK FOOTER //
// ./src/component/administration/registers/product-grid/ProductGrid.tsx